import { render, staticRenderFns } from "./SidebarUserSelect.vue?vue&type=template&id=d54170ee&scoped=true"
import script from "./SidebarUserSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./SidebarUserSelect.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SidebarUserSelect.vue?vue&type=style&index=0&id=d54170ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54170ee",
  null
  
)

export default component.exports